@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../constants/spacing.module.less';

.setup-product-auto-split-modal {
  max-width: 673px;
}

.setup-product-auto-split-list-item {
  padding-bottom: @space-4;
}

.icon {
  height: 26px;
  width: 14px;
  margin-left: @space-4;
}
